import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';

export function handleMinimumFractionDigits(value) {
    return parseFloat(value) % 1 === 0 ? 0 : 2;
}

export default function FormattedPrice(props) {
    return (
        <FormattedNumber
            value={props.value}
            style="currency"
            currency={props.currency}
            // if an amount doesn't have fraction digits, don't display them
            // ie, $100 won't display as $100.00 but $100.10 will display the fraction digits
            // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
            minimumFractionDigits={handleMinimumFractionDigits(props.value)}
        />
    );
}

FormattedPrice.propTypes = {
    currency: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
